import React, { useEffect } from "react";
import {
    styled } from "../ui";
import UiAppBar from "../ui/AppBar";
import Toolbar from "../ui/Toolbar";
import Typography from "../ui/Typography";
import IconButton from "../ui/IconButton";
import Badge from "../ui/Badge";
import MenuIcon from "../ui/icons/Menu";
import HomeIcon from '../ui/icons/Home';
import SearchIcon from '../ui/icons/Search';
import PersonIcon from '../ui/icons/Person';
import "./Navbar.css";
import { MenuItem,
    Box,
    Menu,
    Tooltip,
    Container,
    } from "../ui";
import {
  getAuthSession,
  CartDets,
  DashboardComponent,
  HTTPLASTPART,
  HTTPS,
  STOCKMGMT,
  SUCCESS,
  UPDATEACTIVESHOPSESSION,
  VALIDITYEXPIREDERR,
  getDeviceTypeNew,
  getPreUrlAccordingToCart,
  isEmpty,
  isFeatureAllowed,
  isRoleAllowed,
  offline_enable,
  printDebugLog,
  printInfoLog,
  updateKitchenSessionState,
  ROLE_CREATE,
  ROLE_UPDATE,
  INVSTOCKMGMT,
  FOODITEMPRODUCTMGMT
} from "../../constants/constant";
import { useDispatch, useSelector } from "react-redux";
import { setCartType, setActiveShopHash, setBaseCateogoryData, setBaseProductData } from "../../actions";
import ArrowDropDownIcon from '../ui/icons/ArrowDropDown';
import { snpAxios } from "../global/api";
// import DigitalClock from "../global/clock/DigitalClock";
import { NotificationContainer, NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import SnpButton from "../global/SnpButton";
import NotificationBell from "../notification/NotificationBell";
import { setBaseNotificationRead } from "../dashboard/dashboardNetworkController";
import axios from "axios";
import { useDeviceType } from "../global/hooks/useDeviceType";
const drawerWidth = 270;

const AppBar = styled(UiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    //width: `calc(100% - ${drawerWidth}px)`,
    width: `100%`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function Navbar({ open, toggleDrawer, setComponentIndex, handleLoader, throwValidityError, count, onReadClick, onOpenRestoProductSearch, onOpenComboSearch }) {

  const storeCartType = useSelector(state => state.setCartTypeReducer.cartType);
  const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
  const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorElUser, setAnchorElUser] = React.useState(false);
  const [anchorElShop, setAnchorElShop] = React.useState(false);

  const { isMobile, isTablet } = useDeviceType(getDeviceTypeNew);
  const isMobileOrTablet = isMobile || isTablet;
  const restoSearchSettings = storeCartType === CartDets.Resto && isMobileOrTablet
    ? [
      ...(isRoleAllowed(STOCKMGMT, ROLE_UPDATE) ? ['Search Restaurant Item'] : []),
      ...(isRoleAllowed([INVSTOCKMGMT, FOODITEMPRODUCTMGMT], ROLE_CREATE) ? ['Search Combo'] : []),
    ]
    : [];
  const settings = [...restoSearchSettings, 'Profile', 'Configuration', 'Change Password', 'Recharge Portal', 'Ask For Help', 'Marketing', 'Lock', 'Logout'];
  const offlineSettings = [...restoSearchSettings, 'Profile', 'Configuration', 'Change Password', 'Recharge Portal', 'Ask For Help', 'Marketing', 'Lock', 'Open Offline A2z', 'Logout'];


  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpenShopMenu = (event) => {
    setAnchorElShop(event.currentTarget);
  };

  const handleDashboardNavigation = () => {
    if (getAuthSession().defScreen === DashboardComponent.RESTO_BILLING_UI) return;
    setComponentIndex(-1);
    navigate("/dashboard");
  };

  useEffect(() => {
    printDebugLog("useEffect Navbar", storeActiveShopHash);
  }, [storeCartType, storeActiveShopHash, storeApiUrl]);


  const handleOpenOffline = () => {
    window.open(HTTPS + getAuthSession().offlineIp + HTTPLASTPART + "#/login", "_blank", "noreferrer");
  };

  const handleCloseUserMenu = (event) => {
    //console.log("handleCloseUserMenu : ",event.currentTarget);
    setAnchorElUser(null);
    if (event.currentTarget.id === 'Profile') {
      navigate('/dashboard/profile');
    } else if (event.currentTarget.id === 'Logout') {
      setComponentIndex(DashboardComponent.LOGOUTMESSAGE);
    } else if (event.currentTarget.id === 'Change Password') {
      setComponentIndex(DashboardComponent.PASSWORDDIALOG);
    } else if (event.currentTarget.id === 'Lock') {
      setComponentIndex(DashboardComponent.LOCKDIALOG);
    } else if (event.currentTarget.id === 'Configuration') {
      navigate('/dashboard/configuration');
    } else if (event.currentTarget.id === 'Ask For Help') {
      navigate('/dashboard/help');
    } else if (event.currentTarget.id === 'Marketing') {
      navigate('/dashboard/marketing');
    } else if (event.currentTarget.id === 'Open Offline A2z') {
      handleOpenOffline();
    } else if (event.currentTarget.id === 'Recharge Portal') {
      navigate('/dashboard/recharge-portal');
    } else if (event.currentTarget.id === 'Search Restaurant Item') {
      onOpenRestoProductSearch?.();
    } else if (event.currentTarget.id === 'Search Combo') {
      onOpenComboSearch?.();
    }

  };

  const getKeyByValue = () => {
    return Object.keys(CartDets).find(key => CartDets[key] === storeCartType);
  }

  const getSelKeyByValue = (value) => {
    //console.log("getSelKeyByValue",value);
    return value.location + "(" + Object.keys(CartDets).find(key => CartDets[key] === value.cartType) + ")";
  }

  const getNotifications = async () => {
    try {
      const kUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-notifcations?shopHash=${storeActiveShopHash.id}&read=${false}&onMenu=${true}`;
      const response = await axios.get(kUrl);
      if (response.data.status === SUCCESS) {
        return response.data.jcJson.datas;
      }
    } catch (error) {
      console.error("getNotifications", error);
    }
    return [];
  }


  const updateCartValue = (selectedHash) => {
    //let selectedHash = e.target.value;
    //console.log(selectedHash);
    if (selectedHash != null) {
      //console.log("updateCartValue",selectedHash);
      handleLoader(true);

      const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${UPDATEACTIVESHOPSESSION}`;
      const data = {
        jcJson: {
          apiToken: getAuthSession().apiToken,
          shopHash: selectedHash.id,
        },
      };
      //  console.log("getRestoDetails  => ",data);
      snpAxios
        .post(cartUrl, data)
        .then((response) => {
          printInfoLog("response  => ", response.data);
          handleLoader(false);
          if (response.data.status === SUCCESS) {
            dispatch(setCartType(selectedHash.cartType));
            const payLoad = response.data.jcJson;
            const responseShopHash = updateKitchenSessionState({
              ...selectedHash,
              defScreen: payLoad.defScreen,
              companyName: payLoad.companyName,
              companyWebAddress: payLoad.companyWebAddress,
              companyMail: payLoad.companyMail,
              packages: payLoad.packages,
              onlineDelvMethod: payLoad.onlineDelvMethod,
              validity: payLoad.validity,
              startDate: payLoad.startDate,
              defBalanceType: payLoad.defBalanceType,
              kotCopiesAllowed: payLoad.kotCopiesAllowed,
              defBillUi: Number(payLoad.defBillUi),
            }, payLoad);
            dispatch(setActiveShopHash(responseShopHash));
            const worker = new Worker(new URL('../billing/GetDataFromDbWorker.js', import.meta.url));
            worker.postMessage(responseShopHash.id);
            worker.postMessage("fullData");
            worker.onmessage = (e) => {
              const savedData = e.data;
              printDebugLog("GetDataFromDbWorker navbar", savedData);
              if (savedData !== undefined && savedData.data !== undefined) {
                if ("fullData" === savedData.type) {
                  const dataMap = Object.fromEntries(savedData.data
                    .filter(item => item.id !== response.data.jcJson.id)
                    .map(item => [item.id, item.value]));
                  printDebugLog("dataMap navbar", dataMap)
                  dispatch(setBaseProductData(dataMap));
                } else {
                  dispatch(setBaseCateogoryData(savedData.data.value));
                }
              }
            };
            NotificationManager.success("", "Changed to " + selectedHash.shop + "\nsuccessfully done.");
            navigate("/dashboard");
          } else {
            NotificationManager.error("Changed to " + selectedHash.shop + "\nnot happen.Try again!");
          }
        })
        .catch((error) => {
          handleLoader(false);
          printInfoLog("errr ", error);
          if (VALIDITYEXPIREDERR === error.code) {
            throwValidityError(error.message);
          } else {
            NotificationManager.error("Changed to " + selectedHash.shop + "\nnot happen.Try again!");
          }
          //window.location.href = "#/error";
        });



    }
    setAnchorElShop(null);
  }

  const getTips = () => {
    let data = "";
    if (storeCartType === CartDets.Resto)
      data = "Keyboard Tips!\nAccounting:Ctrl+Alt+a\nBilling:Ctrl+Alt+b\nCateogory:Ctrl+Alt+c\nEmployee:Ctrl+Alt+e\nProfile:Ctrl+Alt+p\nSearch Restaurant Item:Ctrl+Alt+s\nSearch Combo:Ctrl+Alt+m\nLock Screen:Ctrl+Alt+l\nLive Stock Update:Ctrl+Alt+r";
    else
      data = "Keyboard Tips!\nAccounting:Ctrl+Alt+a\nBilling:Ctrl+Alt+b\nCateogory:Ctrl+Alt+c\nEmployee:Ctrl+Alt+e\nInventory Create:Ctrl+Alt+i\nProfile:Ctrl+Alt+p\nSearch Item:Ctrl+Alt+s\nLock Screen:Ctrl+Alt+l";
    return data;
  };

  const handleOnClickNotification = async (id, path) => {
    await setBaseNotificationRead(storeApiUrl.BACKEND_BASE_URL,
      getAuthSession().apiToken, storeActiveShopHash.cartType,
      id);
    onReadClick();
    if (!isEmpty(path)) {
      navigate(path);
    }
  }

  return (
    <AppBar position="absolute" open={open}>
      <NotificationContainer />
      <Container maxWidth="none">
        <Toolbar disableGutters
          sx={{
            pr: "2px", // keep right padding when drawer closed
            color: "black",
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            sx={{
              mr: 2,
              color: "black",
            }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              alignItems: "center",
              flexShrink: 0,
              ml: 1,
              mr: 1,
            }}
          >
            <NotificationBell
              count={count}
              getNotifications={getNotifications}
              onClickNotificationItem={(id, path) => handleOnClickNotification(id, path)}
              onSeeAll={() => navigate("/dashboard/notification")}
            />
          </Box>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}
          >
            <button onClick={handleDashboardNavigation}
              style={{ fontSize: "20px", border: "0", background: "transparent", cursor: "pointer" }}>
              {storeActiveShopHash.shop}
            </button>
          </Typography>

          <HomeIcon
            onClick={handleDashboardNavigation}
            sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} />

          {storeCartType !== CartDets.Resto && isFeatureAllowed(STOCKMGMT) && <SnpButton variant="contained"
            color="primary" onClick={() => setComponentIndex(DashboardComponent.SEARCHDIALOG)} sx={{
              mr: 2, display: { xs: 'none', md: 'flex' }
            }}>
            Search Item
          </SnpButton>}
          {storeCartType !== CartDets.Resto && <SearchIcon
            onClick={() => setComponentIndex(DashboardComponent.SEARCHDIALOG)}
            sx={{ m: 2, display: { xs: 'flex', md: 'none' } }} />}
          <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}>
            {getAuthSession().listShopHash.length > 1 ?
              <div style={{ fontSize: "12px", marginRight: "15px" }}>
                <Typography
                  component="h1"
                  variant="h6"
                  color="inherit"
                  noWrap
                  sx={{ alignContent: "center" }}
                >Current Shop : {getKeyByValue()}
                  <Tooltip title="Open settings">
                    <IconButton color="inherit" onClick={handleOpenShopMenu} sx={{ p: 0 }}>
                      <Badge color="secondary">
                        <ArrowDropDownIcon />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                </Typography></div> : <div style={{ fontSize: "12px", marginRight: "15px" }}>
                <Typography
                  component="h1"
                  variant="h6"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1 }}
                >Current Shop : {getKeyByValue()}</Typography></div>
            }
          </Box>
          <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
            {getAuthSession().listShopHash.length > 1 ?
              <div style={{ fontSize: "8px", marginRight: "5px" }}>
                <Typography
                  component="h1"
                  variant="p"
                  color="inherit"
                  noWrap
                  sx={{ alignContent: "center" }}
                >{getKeyByValue()}
                  <Tooltip title="Open settings">
                    <IconButton color="inherit" onClick={handleOpenShopMenu} sx={{ p: 0 }}>
                      <Badge color="secondary">
                        <ArrowDropDownIcon />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                </Typography></div> : <div style={{ fontSize: "8px", marginRight: "5px" }}>
                <Typography
                  component="h1"
                  variant="h6"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1 }}
                >{getKeyByValue()}</Typography></div>
            }
          </Box>
          <Menu
            sx={{ mt: '45px' }}
            id="menu-shopbar"
            anchorEl={anchorElShop}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElShop)}
            onClose={(e) => updateCartValue(null)}
          >
            {getAuthSession().listShopHash.map((shopHash) => (
              <MenuItem key={shopHash.id} id={shopHash.id} sx={{
                "&:hover": {
                  backgroundColor: "#00333e",
                  color: "white",
                },
              }} onClick={(e) => updateCartValue(shopHash)}>
                {
                  storeActiveShopHash.id === shopHash.id ?
                    <Typography textAlign="center" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', color: "#2f1160", fontWeight: 'bold' }}>{getSelKeyByValue(shopHash)}</Typography>
                    : <Typography textAlign="center" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{getSelKeyByValue(shopHash)}</Typography>
                }
              </MenuItem>
            ))}
          </Menu>
          {
            !isMobile && <Tooltip title={getTips()}>
              <img alt="tips" style={{ width: "4%", height: "4%", borderRadius: "90%" }} src="./tips.png" />
            </Tooltip>
          }


          &nbsp;
          {
            getAuthSession().pImg && <div>
              <img alt="" src={storeApiUrl.BACKEND_BASE_URL + "files/" + getAuthSession().pImg} style={{ width: "30%", height: "30%" }} />
            </div>
          }
          &nbsp;
          <div>
            {getAuthSession().userName + " "}
          </div>
          <Box sx={{ display: { xs: "none", md: "flex" }, ml: 2 }}>
            <NotificationBell
              count={count}
              getNotifications={getNotifications}
              onClickNotificationItem={(id, path) => handleOnClickNotification(id, path)}
              onSeeAll={() => navigate("/dashboard/notification")}
            />
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton color="inherit" onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Badge color="secondary">
                  <PersonIcon />
                </Badge>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {((getAuthSession().offlineIpSet && offline_enable) ? offlineSettings : settings).map((setting) => (
                <MenuItem key={setting} id={setting} sx={{
                  "&:hover": {
                    backgroundColor: "#00333e",
                    color: "white",
                  },
                }} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          {/* { test_environment_mode && <DigitalClock/> } */}
        </Toolbar>
      </Container>
    </AppBar >
  );
}
